module.exports = __webpack_public_path__ + "img/app-library.36916bc5.jpg";